<template>
    <base-dropdown>
        <template #title-container><li class="nav-item dropdown">
            <span class="nav-link font-weight-bold cursor-pointer">{{$t('common.anonymous')}}</span>
        </li></template>
        <span class="dropdown-item nch--nav-link" @click="logoutUser">
            <i class="ni ni-user-run"></i>
            <span>{{$t('header.profile.logout')}}</span>
        </span>
    </base-dropdown>
</template>

<script>
import BaseDropdown from "../../argon/components/BaseDropdown";
export default {
    name: "NavbarPublicUser",
    components: {
        BaseDropdown
    },
    methods: {
        logoutUser() {
            this.$loading.show();

            window.axios
                .post("/logout")
                .then(response => {
                    setTimeout(() => {
                        localStorage.removeItem("nochalks_token");
                        location.href = "/";
                    }, 150);
                })
                .catch(error => {
                    setTimeout(() => {
                        this.$notify({
                            type: "danger",
                            message: this.$t("login.messages.error")
                        });
                    }, 150);
                });
        }
    }
};
</script>

<style>
</style>